import React, { CSSProperties, MouseEventHandler } from "react";


interface IUnderlinedBtn {
    text: string
    type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type']
    onClickFn?: MouseEventHandler
};


export default ({ text, type, onClickFn }: IUnderlinedBtn) => {
    const styles: CSSProperties = {
        cursor: 'pointer',
        color: '#6F217B',
        backgroundColor: 'transparent',
        textDecoration: 'underline',
        border: 'none',
        padding: '0',
    };

    return (
        <button type={type || 'submit'} style={styles} onClick={onClickFn}>
            {text}
        </button>
    );
};
